import { Component, Input, OnInit } from "@angular/core";
import { QuestionEntity } from "src/app/models/new-product/base/question-entity.model";
import { ProposalConst } from "src/app/models/new-product/sme/mortgage-fire/singapore/base/mf-sg-proposal-constant";

@Component({
    selector: "yes-no-radio-question",
    templateUrl: "./yes-no-radio-question.component.html",
    styleUrls: ["./yes-no-radio-question.component.scss"],
    standalone: false
})
export class YesNoRadioQuestionComponent implements OnInit {
  noAnswerDefaultText = ProposalConst.noAnswerDefaultText;
  @Input() public question!: QuestionEntity;
  constructor() {}

  ngOnInit(): void {}

  answerDisplayText = (question: QuestionEntity) => {
    let answerDisplayText: string = "";
    /*this.answer = "1";*/
    question.options.forEach((option) => {
      if (option.value === question.answer) {
        answerDisplayText = option.key;
      }
    });
    return answerDisplayText;
  };
}
